import { useEffect, useRef } from 'react'
import EventEmitter from "events"

export interface IEventProps {
  name: string,
  handle: (msg?: any) => void
}

export enum AppEvents {
  UPDATE_AIRDROP_DETAIL = 'updateAirdropDetail',
  TOKEN_TRADE = 'tokenTrade',
  // CURVE_BASE_CHANGE = 'curveBaseChange'
}

// App级别事件
const appEvent = new EventEmitter();
export const useAppEvent = () => {
  const eventListRef = useRef<IEventProps[]>([])

  const on = (
    name: IEventProps['name'],
    handle: IEventProps['handle']
  ) => {
    appEvent.on(name, handle)
    eventListRef.current.push({ name, handle })
  }

  const emit = (
    name: IEventProps['name'],
    msg?: any
  ) => {
    appEvent.emit(name, msg)
  }

  const off = (
    name: IEventProps['name'],
    handle: IEventProps['handle']
  ) => {
    appEvent.off(name, handle)
    const index = eventListRef.current.findIndex((item) => item.name === name && item.handle === handle)
    if (index >= 0) {
      eventListRef.current.splice(index, 1)
    }
  }

  useEffect(() => {
    const eventList = eventListRef.current
    return () => {
      eventList?.forEach((event) => {
        appEvent.off(event.name, event.handle)
      })
    }
  }, [])

  return {
    emitter: appEvent,
    on,
    off,
    emit,
  }
}

